<template>
  <section class="bonus">
    <div class="item">
      <span>环保补助金:</span>
      <span>-¥{{product.bonus_price}}</span>
      <span>应付金额: ¥</span>
      <span>{{order.amount}}</span>
    </div>
  </section>
</template>

<script>
export default {
  props: ["product","order"]
};
</script>

<style scoped>
.bonus {
  width: 100%;
  margin: 10px 0;
  background: #fff;
  padding: 20px 20px;
}
.bonus .item{text-align: right;}
.bonus .item span{color: #666;font-size:16px;}
.bonus .item span:nth-child(1){
    color: #999;
}
.bonus .item span:nth-child(2){
    color: #111;
    margin:0 160px 0 10px;
}
.bonus .item span:nth-child(3){
    color: #f9415d;
}
.bonus .item span:nth-child(4){
    color: #f9415d;
    font-size: 20px;
}
</style>
